module.exports = __webpack_public_path__ + "static/media/5.445c8f93.jpg";